function moveBanners(grid = 1) {
    if(document.querySelector('.plp-insert-banner-section')){
        const range = parseInt(document.querySelector('.plp-insert-banner-section').getAttribute('data-range'));
        const banners = document.querySelectorAll('.mobile-banner.mb-shuffle');

        banners.forEach((banner, index) => {
            const targetIndex = range * (index + 1) * grid;
            const targetProductBlock = document.querySelector(`product-block[data-index="${targetIndex}"]`);

            if (targetProductBlock) {
                // Insert the banner after the target product block
                targetProductBlock.insertAdjacentElement('afterend', banner);
                // Dynamically set the grid span for the banner
                banner.style.setProperty('--grid-span-mb', `span ${grid}`);
            } else {
                console.warn(`Target product block not found for banner at index ${index}`);
            }
        });
    }
}